<template>
  <div>
    <div class="column-align-start Alert-div" :style="{width: style_css + '%'}">
      <div class="row-start">
        <i class="el-alert__icon el-icon-info"></i>
        <p>{{title}}</p>
      </div>
      <ul v-show="!state">
        <li v-for="(item,index) in content" :key="item+index">{{item}}</li>
      </ul>
      <img src="./image/Alert_add.png" class="Alert_add cursor" v-if="state" @click="Alert_add"/>
      <img src="./image/Alert_minus.png" class="Alert_add cursor" v-else @click="Alert_minus"/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '操作提示'
    },
    content: {
      type: Array,
      default () {
        return ['1.展示平台所有商品分类;', '2.可添加子分类并进行编辑删除等操作；']
      }
    }
  },
  name: 'Alert',
  data () {
    return {
      state: false,
      style_css: 100
    }
  },
  methods: {
    Alert_add () {
      this.style_css = 100
      this.state = false
    },
    Alert_minus () {
      this.style_css = 10
      this.state = true
    }
  }
}
</script>

<style scoped>
@import "style/Alert.css";
</style>



// WEBPACK FOOTER //
// src/components/Alert/Alert.vue